import { Tool } from './base';

export class QRadarTool extends Tool {
  public readonly toolName = 'QRadar Query';

  public readonly toolDefaultCCMFieldMappings = {
    //action: '', // No logging contains this value and is normalized by SIEM -- QRadar maps multiple event names based on success
    //dns_query: 'NETWORK',
    //domain: 'AccountDomain', //Field extraction existed but lacked proper regex -- Custom extraction
    //logon_process: 'Logon Process', //Non-default -- Custom extraction
    //object_loaded: 'Object Loaded', //Non-default -- Custom extraction
    //parent_process_cmdline: 'Parent Process CommandLine', //Non-default -- Custom extraction
    //registry_new_value_name: 'Registry New Value', //Non-default -- Missing logs to extract, but can predict name (4657)
    //registry_old_value_name: 'Registry Old Value', //Non-default -- Missing logs to extract, but can predict name (4657)
    //request_method: 'NETWORK',
    //service_file_name: 'Service File Name', //Non-default -- Custom extraction
    //status_code: 'NETWORK',
    //task_category: 'Event Category', //Normalized by QRadar -- may not match out logic
    //uri: 'NETWORK',
    //url: 'NETWORK',
    //user_agent: 'NETWORK',
    target_path: 'Target File Directory',
    application_name: 'Application Name',
    accesses: 'Accesses',
    dest_ip: 'Destination IP',
    dest_port: 'Destination Port',
    event_id: 'EventID',
    file_name: 'FileName',
    file_path: 'File Path',
    hostname: 'Machine ID',
    logon_type: 'Logon Type',
    message: 'Message',
    object_name: 'ObjectName',
    parent_process_path: 'Parent Process Path',
    process_cmdline: 'Process CommandLine',
    process_name: 'Process Name',
    process_path: 'Process Path',
    registry_key_name: 'Registry Value Name',
    registry_path: 'Registry Key',
    registry_value_name: 'Registry Value Data',
    service_name: 'Service Name',
    src_ip: 'Source IP',
    username: 'Username',
  };

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const qradarResponseSearchURI =
      'console/do/ariel/arielSearch?appName=EventViewer&pageId=EventList&dispatch=performSearch&value(searchMode)=AQL&searchOrigin=SEARCH_RESULTS_AQL&value(timeRangeType)=aqlTime&value(interval)=300000&value(searchName)=&value(searchId)=null&value(aql)=';
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    const encodedRenderedContentStringified = encodeURIComponent(
      `[${JSON.stringify(renderedContent)}]`
    );
    return `${rootURL}${qradarResponseSearchURI}${encodedRenderedContent}&value(aqlLines)=${encodedRenderedContentStringified}`;
  }
}
